// extracted by mini-css-extract-plugin
export default {"grid":"Range_grid__qgtAC"};